import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Container,
  Header,
  Form,
  Label,
  Input,
  Select,
  Textarea,
  ImageSlider,
  ImageWrapper,
  PreviewImage,
  ImageControls,
  SectionTitle,
  ErrorMessage,
  InputGroup,
  InputWrapper,
  RadioWrapper,
  InputMonetario
} from "./styles";
import Button from "../../components/Button";

const CadastroImovel = () => {
  const [formData, setFormData] = useState({
    tipo: "Casa",
    finalidade: "Residencial",
    endereco: "",
    cidade: "",
    estado: "MT",
    valor: "",
    descricao: "",
    destaque: "0",
    quartos: "0",
    banheiros: "0",
    vagas: "0",
    urlMaps: ""
  });
  const [erro, setErro] = useState("");
  const estados = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
                   "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
                   "RS", "RO", "RR", "SC", "SP", "SE", "TO"];
  const [searchParams] = useSearchParams();
  const slug = searchParams.get("slug");
  const navigate = useNavigate();

  const [imagensAntigas, setImagensAntigas] = useState([]);
  const [imagensNovas, setImagensNovas] = useState([]);
  const [imagemPrincipal, setImagemPrincipal] = useState(null);
  const [imagensParaExcluir, setImagensParaExcluir] = useState([]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const novas = files.filter(file => file.type.startsWith("image/"));

    const arquivosUnicos = novas.filter(nova =>
      !imagensNovas.some(img => img.name === nova.name && img.size === nova.size)
    );

    setImagensNovas((prev) => [...prev, ...arquivosUnicos]);
  };

  const handlePrincipalChange = (id) => {
    setImagemPrincipal(id);
  };

  const excluirImagemNova = (index) => {
    setImagensNovas((prev) => prev.filter((_, i) => i !== index));
    if (imagemPrincipal === `nova-${index}`) {
      setImagemPrincipal(null);
    }
  };

  const atualizarImagens = async () => {
    for (const id of imagensParaExcluir) {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/index.php?rota=imagens&id=${id}`, {
          method: "DELETE",
          credentials: 'include'
        });

        if (!res.ok) {
          setErro(`Erro ao excluir imagem com ID ${id}`);
        }
      } catch {
        setErro(`Erro de conexão ao excluir imagem com ID ${id}`);
      }
    }

    setImagensParaExcluir([]); // limpa após atualizar
  };

  const marcarParaExcluir = (id) => {
    const confirm = window.confirm("Deseja realmente excluir esta imagem?");
    if (!confirm) return;

    setImagensParaExcluir((prev) => [...prev, id]);
    setImagensAntigas((prev) => prev.filter((img) => img.id !== id));

    if (imagemPrincipal === `antiga-${id}`) {
      setImagemPrincipal(null);
    }
  };

  useEffect(() => {
    if (slug) {
      fetch(`${process.env.REACT_APP_API_URL}/index.php?rota=imoveis&slug=${slug}`, {
        credentials: 'include'
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.sucesso && data.imovel) {
            const imovel = data.imovel;

            setFormData({
              tipo: imovel.tipo || "",
              finalidade: imovel.finalidade || "",
              endereco: imovel.endereco || "",
              cidade: imovel.cidade || "",
              estado: imovel.estado || "",
              valor: imovel.valor || "",
              descricao: imovel.descricao || "",
              destaque: imovel.destaque || "",
              quartos: imovel.quartos || "",
              banheiros: imovel.banheiros || "",
              vagas: imovel.vagas || "",
              urlMaps: imovel.urlmaps || ""
            });

            setImagensAntigas(imovel.imagens || []);

            const principalIndex = imovel.imagens?.findIndex(img => img.principal === 1);
            if (principalIndex >= 0) {
              setImagemPrincipal(`antiga-${imovel.imagens[principalIndex].id}`);
            }
          } else {
            setErro("Erro ao carregar dados do imóvel");
          }
        })
        .catch(() => setErro("Erro ao carregar imóvel"));
    }
  }, [slug]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await atualizarImagens();

    const formDataToSend = new FormData();
    if (slug)
      formDataToSend.append("_method", "PUT");
    formDataToSend.append("tipo", formData.tipo);
    formDataToSend.append("finalidade", formData.finalidade);
    formDataToSend.append("endereco", formData.endereco);
    formDataToSend.append("cidade", formData.cidade);
    formDataToSend.append("estado", formData.estado);
    formDataToSend.append("valor", formData.valor);
    formDataToSend.append("descricao", formData.descricao);
    formDataToSend.append("destaque", Number(formData.destaque));
    formDataToSend.append("quartos", formData.quartos);
    formDataToSend.append("banheiros", formData.banheiros);
    formDataToSend.append("vagas", formData.vagas);
    formDataToSend.append("urlMaps", formData.urlMaps);

    imagensNovas.forEach((img, index) => {
      formDataToSend.append("imagens[]", img);
      if (imagemPrincipal === `nova-${index}`) {
        formDataToSend.append("principal_index", index);
      }
    });

    if (imagemPrincipal?.startsWith("antiga-")) {
      const principalId = imagemPrincipal.split("-")[1];
      formDataToSend.append("principal_antiga_id", principalId);
    }

    imagensParaExcluir.forEach((id) => {
      formDataToSend.append("imagens_para_excluir[]", id);
    });
    
    const method = "POST";
    const url = `${process.env.REACT_APP_API_URL}/index.php?rota=imoveis${slug ? `&slug=${slug}` : ""}`;

    try {
      const res = await fetch(url, {
        method,
        credentials: 'include',
        body: formDataToSend,
      });

      const data = await res.json();
      if (res.ok) {
        navigate("/dashboard");
      } else {
        setErro(data.erro || "Erro ao salvar imóvel");
      }
    } catch {
      setErro("Erro de conexão com o servidor");
    }
  };

  return (
    <Container>
      <Header>
        <h2>{slug ? "Editar Imóvel" : "Cadastrar Imóvel"}</h2>
        <Button onClick={() => navigate("/dashboard")}>Voltar</Button>
      </Header>

      <Form onSubmit={handleSubmit}>
        <Input type="hidden" name="_method" value="PUT" />
        <Label>Tipo</Label>
        <Select name="tipo" value={formData.tipo} onChange={handleChange}>
          <option value="Casa">Casa</option>
          <option value="Lote">Lote</option>
          <option value="Apartamento">Apartamento</option>
          <option value="Rural">Rural</option>
        </Select>
        <Label>Finalidade</Label>
        <Select name="finalidade" value={formData.finalidade} onChange={handleChange}>
          <option value="Residencial">Residencial</option>
          <option value="Comercial">Comercial</option>
        </Select>

        <Label>Endereço</Label>
        <Input name="endereco" value={formData.endereco} onChange={handleChange} />
        <InputGroup>
          <InputWrapper>
            <Label>Cidade</Label>
            <Input name="cidade" value={formData.cidade} onChange={handleChange} />
          </InputWrapper>
          <InputWrapper>
            <Label>Estado</Label>
            <Select name="estado" value={formData.estado} onChange={handleChange} >
              {estados.map((uf) => (<option key={uf} value={uf}> {uf} </option>))}
            </Select>
          </InputWrapper> 
        </InputGroup>

        <Label>Valor (R$)</Label>
        <InputMonetario
          name="valor"
          prefix="R$ "
          decimalsLimit={2}
          decimalSeparator=","
          groupSeparator="."
          value={formData.valor}
          onValueChange={(value) => {
            setFormData({ ...formData, valor: value });
          }}
        />

        <Label>Descrição</Label>
        <Textarea name="descricao" value={formData.descricao} onChange={handleChange} />

        <RadioWrapper>
          <Input name="destaque" 
                  type="checkbox"
                  checked={formData.destaque === 1}
                  onChange={(e) => setFormData({ ...formData, destaque: e.target.checked ? 1 : 0 })}/>
          <Label>Em destaque?</Label>
        </RadioWrapper>  

        <InputGroup>
          <InputWrapper>
            <Label>Quartos</Label>
            <Input name="quartos" type="number" value={formData.quartos} onChange={handleChange} min={0} />
          </InputWrapper>
          <InputWrapper>
            <Label>Banheiros</Label>
            <Input name="banheiros" type="number" value={formData.banheiros} onChange={handleChange} min={0} />
          </InputWrapper>
          <InputWrapper>
            <Label>Vagas de garagem</Label>
            <Input name="vagas" type="number" value={formData.vagas} onChange={handleChange} min={0}/ >
          </InputWrapper>
        </InputGroup>

        <Label>Link do Google Maps</Label>
        <Input name="urlMaps" placeholder="Você encontra o link na opção de compartilhar do Google Maps." value={formData.urlMaps} onChange={handleChange} />

        <Label>Novas imagens</Label>
        <Input type="file" multiple onChange={handleFileChange} accept="image/*" />       

        <SectionTitle>Novas imagens:</SectionTitle>
        <ImageSlider>
          {imagensNovas.map((img, index) => (
            <ImageWrapper key={index}>
              <PreviewImage src={URL.createObjectURL(img)} alt={`Nova ${index + 1}`} />
              <ImageControls>
                <RadioWrapper>
                  <Input name="principal" type="radio" checked={imagemPrincipal === `nova-${index}`} onChange={() => handlePrincipalChange(`nova-${index}`)} />
                  <Label>Principal</Label>
                </RadioWrapper>
                <Button onClick={() => excluirImagemNova(index)}>
                  Excluir
                </Button>
              </ImageControls>
            </ImageWrapper>
          ))}
        </ImageSlider>

        <SectionTitle>Imagens já cadastradas:</SectionTitle>
        <ImageSlider>
          {imagensAntigas.map((img) => (
              <ImageWrapper key={img.id}>
                <PreviewImage src={`${process.env.REACT_APP_API_URL}/${img.caminho}`} alt="Imagem cadastrada" />
                <ImageControls>
                  <RadioWrapper>
                    <Input name="principal" type="radio" checked={imagemPrincipal === `antiga-${img.id}`} onChange={() => handlePrincipalChange(`antiga-${img.id}`)} />
                    <Label>Principal</Label>
                  </RadioWrapper>
                  <Button onClick={() => marcarParaExcluir(img.id)}>Excluir</Button>
                </ImageControls>
              </ImageWrapper>
          ))}
        </ImageSlider>

        <Button type="submit">{slug ? "Atualizar" : "Cadastrar"}</Button>
        {erro && <ErrorMessage>{erro}</ErrorMessage>}
      </Form>
    </Container>
  );
};

export default CadastroImovel;